import React from "react";

import Text from "src/components/text";

import { Analytics, CollectionItem } from "src/types/reports";

import _ from "lodash";
import styles from "./collectionCard.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";


export interface CollectionActivityItem {
  collection: CollectionItem;
  analytics: Analytics;
}

export interface CollectionCardProps {
  item: CollectionActivityItem;
}

export const CollectionCard: React.FC<CollectionCardProps> = ({ item }) => {
  const { collection, analytics } = item;

  const createdBy = collection.createdBy?.firstName
  ? `${collection.createdBy.firstName} ${collection.createdBy.lastName || ""}`.trim()
  : "Unknown";

  return (
    <a
      href={`/collections/${collection.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.linkWrapper}
    >
      <div className={styles.card}>
        <img
          src={collection.icon?.thumbnail || DefaultAssetIcon}
          alt={collection.name}
          className={styles.thumbnailIcon}
        />
        <div className={styles.content}>
          <Text
            lines={1}
            className={styles.title}
            text={collection.name || ""}
          />
          <div className={styles.metrics}>
            <span>{collection.assetsCount || 0} Assets</span>
            <span>{analytics.views || 0} Views</span>
            <span>{analytics.shares || 0} Shares</span>
          </div>
          <div className={styles.meta}>
            Created by: {" "}
            <Text lines={1} className={styles.author} text={createdBy} />
          </div>
        </div>
      </div>
    </a>
  );
};
